import React from "react";
import Style from "./ProductSlide.module.css";
import Theme from "../../../theme.module.css";


export default function Unleashed({setModalOpen}) {

    return (
        <div>
            <div className={`${Theme.columns} ${Style.unleashed} animateColumns`}>
                <div className={`${Theme.textCont} ${Style.productImageCont}`}>
                    <img src={require('../../../assets/gnarly-sync-unleashed-woocommerce.jpg')} alt="unleashed-woocommerce-sync" />
                </div>
                <div style={{textAlign: "right"}}>
                    <div className={Style.productSelectBtnCont}>
                        <a className={Style.freeTrialFlash}>14 Day Free Trial!</a>
                        <a>Subscription / Licence</a>
                    </div>
                    <h1 Style={{textAlign: "right"}}>Gnarly Sync - Unleashed WooCommerce Integration</h1>
                    <div className={`${Theme.textCont} ${Style.textCont}`}>
                        <p>Sync product stock, customers & orders between Unleashed & Woocommerce.</p>
                        <p>We will:</p>
                        <ul>
                            <li>Provide our main integration plugin</li>
                            <li>Assist in the configuration of the plugin if required</li>
                            <li>Provide integration support</li>
                            <li>Extend the plugin inline with your own integration requirements where required (via a bespoke child plugin)</li>
                        </ul>
                    </div>
                    <div className={Style.productButtons}>
                        <a className={Style.readMore} onClick={() => setModalOpen('contact-form')}>Arrange a call</a>  |  <a href="https://store.gnar.co.uk/product/gnarly-sync-unleashed-woocommerce/" target="_blank" className={Style.readMore}>Pricing</a>
                    </div>
                    <a href="https://store.gnar.co.uk/?add-to-cart=7003" className={Theme.greenButton}>Sign up</a>
                </div>
            </div>
        </div>
    );
}